module.exports = __webpack_public_path__ + "img/homeSec01Top3.a7f73229.jpg";